import "./Screens.css";
import { LeaseApplicationStatusTypesEnum } from "@propertelligent/client-api";
import AddTraspButton from "../firstTimeUserExperience/commonCom/AddTraspButton";
import AddButtonWithArrow from "../firstTimeUserExperience/commonCom/AddButtonWithArrow";
import { CustomInputTextArea } from "../common/formControls";

const ApprovedScreen = ({ status, setShowModel, interalTenant, setInteralTenant, noteTenant, setNoteTenant, setShowConfirmation }) => {
  const handleChange = (e) => { setInteralTenant(e.target.value) };
  const handleTenantChange = (e) => { setNoteTenant(e.target.value) };
  const handleCancel = () => {
    setInteralTenant("")
    setNoteTenant("")
    setShowModel(false)
  }
  const handleSubmit = (e) => {
    e.preventDefault()
    setShowModel(false)
    setTimeout(() => {
      setShowConfirmation(true)
    }, 100);
  }
  return (
    <>
      {/* <div > */}
        <form onSubmit={handleSubmit} className="approved-app-form">
          <div className="InnerBody">
            <div className="d-flex flex-column gap-2">
            <CustomInputTextArea
              label="Internal Notes"
              name={undefined}
              placeholder="Add note here..."
             
              isFormControl
              required={false}
              value={interalTenant}
              onChange={handleChange}
              isError={ false}
              errorMessages="Add required "
              myClassName="normal_text black w-100 mb-3"
              rows={3}
            /></div>
            <p className="sub_text grey_subtext1 my-1">This is internal notes and would not be sent to Tenant </p>
            <br />
            <div className="d-flex flex-column gap-2">
            <CustomInputTextArea
              label="Tenant Notes"
              name={undefined}
              placeholder="Add note here..."
              required={false}
              isFormControl
              value={noteTenant}
              onChange={handleTenantChange}
              isError={false}
              errorMessages="Add required "
              myClassName="normal_text black w-100 p-3"
              rows={3}
            /></div>
            <p className="sub_text grey_subtext1 mt-3">This note will be sent to Tenant</p>
          </div>
          <div className="form-actions-footer">
            <AddTraspButton
              type="button"
              border={false}
              onClick={handleCancel}
              bname="Cancel"
              width={"fit-content"}
            />
            {status == LeaseApplicationStatusTypesEnum.Approved ? (
              <>
                <AddButtonWithArrow
                  type="submit"
                  buttonname={"Approve"}
                  // onClick={() => {
                  //   setShowModel(false)
                  //   setTimeout(() => {
                  //     setShowConfirmation(true)
                  //   }, 100);
                  // }}
                  minWidth={"fit-content"}
                />
                {/* <div className="actionsDropdownContainer clickable">
                <CustomDropDownMenu Action={true} Element={<img src={GetImages.BlueChevronDown} alt="BlueChevronDown" />} data={actions} />
              </div> */}
              </>
            ) :
              <AddButtonWithArrow
                type="submit"
                buttonname={"Close"}
                // onClick={() => {
                //   setShowModel(false)
                //   setTimeout(() => {
                //     setShowConfirmation(true)
                //   }, 100);
                // }}
                minWidth={"fit-content"}
              />
            }
          </div>
        </form>
      {/* </div> */}
    </>
  );
};

export default ApprovedScreen;
